import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionTagUpdateInput } from '../generated/globalTypes';
import { updateQuestionTagMutation, updateQuestionTagMutationVariables } from '../generated/updateQuestionTagMutation';
import { questionTagFieldsFragment } from '../models/QuestionTag';

/**
 * Get a callback to update a QuestionTag in the store.
 */
export function useUpdateQuestionTagCallback(): [(id: string, model: QuestionTagUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateQuestionTagMutation, updateQuestionTagMutationVariables>(
        gql`
            mutation updateQuestionTagMutation ($model: QuestionTagUpdateInput!) {
                updateQuestionTag(model: $model) {
                    ...questionTagFields
                }
            }

            ${questionTagFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: QuestionTagUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
